export enum RequestType {
  POST = 0,
  GET = 1
}
